import { useHistory } from 'react-router';

export const useRedirectToKeepHash = (...routes: string[]) => {
  const { location } = useHistory();
  return routes.map((route) => ({
    pathname: route,
    hash: location.hash,
  }));
};
